import { useMemo } from "react";
import { useSelector } from "react-redux";
import { translationsSelector } from "store/selectors/app";

export default function Translation({
  label,
  withElement,
  onClick,
  className,
  style,
}) {
  // const translations = useSelector(translationsSelector, shallowEqual);
  const translations = useSelector(translationsSelector);
  const clickHandler = onClick || null;
  const labelValue = useMemo(() => {
    const translateLabel = translations[label] ? translations[label] : label;
    return typeof label === "string" || typeof label === "number"
      ? translateLabel
      : "";
  }, [translations, label]);

  return withElement ? (
    <p className={className} style={style} onClick={clickHandler}>
      {labelValue}
    </p>
  ) : (
    labelValue
  );
}
